export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-digg-3a2f526a5ef1bf63135b32974e2ed902.svg";